import React, { useContext, useState } from 'react';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import '../styles/OfferLetterRequestForm.css';
import Button from 'react-bootstrap/Button';
import { loginRequest } from "../authConfig";
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Checkbox, Switch } from '@material-ui/core';
import { FormControlLabel, FormGroup } from '@mui/material';
import { AlertContext } from '../AlertContext';

/**
 * Takes user input and strips out unsafe characters
 * @param {string} input - user input
 * @returns cleaned string
 */
function sanitize(input) {
    if(input) {
        var output = ''
        const regex = /drop table|alter table|delete from|[$;'*<>"{}[\]]|--|\/\*|xp_/gi
        output = input.replaceAll(regex, '').trim()
        return output;
    } else {
        return input
    }
}

function OfferLetterRequestForm() {
    const { instance, accounts } = useMsal();
    const [submit, setSubmit] = useState(false);
    const [userResponse, setUserResponse] = useState('');
    const [token, setToken] = useState();
    const [location, setLocation] = useState();
    const [companyNames, setCompanyNames] = useState([]);
    const [companyLocations, setCompanyLocations] = useState([]);
    const [workLocation, setWorkLocation] = useState();
    const [wis, setWis] = useState();
    const [rehire, setRehire] = useState();
    const [provideCellPhone, setProvideCellPhone] = useState();
    const [sageAccess, setSageAccess] = useState();
    const [showSimilarSageEmployee, setShowSimilarSageEmployee] = useState(false);
    const [employeeState, setEmployeeState] = useState();
    const [showShippingAddress, setShowShippingAddress] = useState(false);
    const [businesscards, setBusinesscards] = useState();
    const [cctype, setCctype] = useState();
    const [state, setState] = useState({ name: "", email: "",  date_of_hire: "", position: "", work_location: "", report_to: "", hourly_rate: "", annual_salary: "", bonus:"", vacation:"", per_diem:"", auto_allowance:"",  cell_phone_reimbursement:"", company_credit_card:"", company_credit_card_limit:"", business_cards:"", company_equipment:"", work_in_state:"", commission:"", comments:"", weekly_base_salary: "", ot_rate: "", five_day_pd: "", seven_day_pd: "", manager_title: "", pe_street_address: "", pe_city: "", pe_state: "", pe_zip: ""});
    const [show, setShow] = useState(false);
    const [itMade, setItMade] = useState(false);
    const [itState, setItState] = useState({employee_name: '', pe_middle_name: '', keyboard_mouse: false, mapped_drives: false, vpn_access: false, docking_station: false, sage_access: '', similar_sage_employee: '', provide_cell_phone: '', cell_phone_type: '', rehire: '', department: '', cell_phone_number: '', start_date: '', work_company:null, work_location:'', similar_employee:'', computer:'', monitors:'', report_to:'', requested_software:'', other_requests:''});
    const isAuthenticated = useIsAuthenticated();
    const [redirect, setRedirect] = useState(false) // whether or not we're on this page from a redirect
    const { alert } = useContext(AlertContext)
    const [control, setControl] = useState(true);

    // These are the links that will be replaced upon deployment via the pipeline - localhost will become func link
    // const api_url = 'http://localhost:7071/api/hrol/';
    // const api_url = 'https://func-hrol-dev-api.azurewebsites.net/api/hrol/';
    const api_url = 'https://func-hrol-api-prod.azurewebsites.net/api/hrol/';

    React.useEffect(() => {
        if(isAuthenticated) { OLFPageSetup(true); }
        // eslint-disable-next-line
    }, [isAuthenticated]);

    /**
     * Handles validation for various input fields on the page
     * @param {*} name - the field name, vacation, street address, etc
     * @param {*} input - the value from the field being passed
     */
    function validate(name, input) {
        const requiredFields = ['name', 'email', 'date_of_hire', 'position', 'report_to', 'manager_title', 'work_in_state', 'work_location']

        if(requiredFields.includes(name) && (input === null || input === '' || input === undefined) ) {
            alert("Missing required fields! All fields bordered in red must be filled out before submission is allowed!");
            return false;
        } else {
            switch (name) {
                case 'vacation':
                    let validNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
                    // input is not empty AND if vacation field is not a number OR input is not empty AND it is a number and is not in the list of valid numbers
                    if((input && !parseInt(input)) || (input && (parseInt(input) && !validNumbers.includes(input)) )) {
                        alert("Vacation must be a number! Ex: 1, 2, 3, etc...")
                        return false
                    }
                    break;
                default:
                    break;
            }
            return true
        }
    }

    /**
     * Function that creates a new MSAL request object with a blank redirect, which is then used with acquireTokenPopup to try to automatically retrieve a new access token for the user
     * @param {string} functionName the name of the function (& any parameters) as a string that will be parsed by eval() for execution
     */
    function requiredReauthentication(functionName) {
        const request = {
            ...loginRequest,
            account: accounts[0],
            redirectUri: "https://hrol.iss-digital.com/blank.html"  // based on this GitHub issue, in order for a acquireTokenPopup to work, we need to redirect to a blank page instead of our homepage. https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4573#issuecomment-1071143506
        };

        console.log('Reauthentication Required')
        instance.acquireTokenPopup(request).then((response) => {
            setToken(response);
            setControl(true)
            // eslint-disable-next-line
            eval(functionName)
        });
    }

    /**
     * Offer letter form page setup
     * @param {boolean} pageLoad flag to determine whether to fetch company info
     */
    function OLFPageSetup(pageLoad) {
        const request = {
            ...loginRequest,
            account: accounts[0]
        };

        if(control) {
            // Silently acquires an access token which is then attached to a request for Microsoft Graph data
            instance.acquireTokenSilent(request).then((response) => {
                setToken(response);
                setRedirect(false)

                // first page load
                if(pageLoad) {
                    var tempRedirect = false; // setting temp redirect so we can immediately use the var in this function
                    if(window.sessionStorage.getItem('results') !== null) {
                        tempRedirect = true
                        setRedirect(true)
                    }

                    let redirectState = window.sessionStorage.getItem('results') // get state from session storage
                    if(redirectState !== null && tempRedirect === true) {
                        handleRedirect(redirectState, response.idToken)
                    }

                    window.sessionStorage.removeItem('results') // clear state from session storage so that these values only stay populated when redirected

                    fetch((api_url + 'legal_company_names'), {headers: {Authorization: response.idToken}, method: 'GET'}).then((response) => response.json())
                    .then((json) => {
                        if(json.status === 401 && json.message.includes('Reauthentication Required')){
                            throw new Error('Reauthentication Required')
                        }
                        json.forEach(element => {
                            element.label = element.company_name
                            element.value = element.company_name
                        });
                        fetch(api_url + 'company_locations', {headers: {Authorization: response.idToken}, method: 'GET'}).then((resp) => resp.json())
                        .then((locJson) => {
                            locJson.forEach(el => {
                                el.label = el.city + ', ' + el.state
                                el.value = el.label
                            })
                            setCompanyLocations(locJson)
                        })
                        setCompanyNames(json) // set state variable for Select dropdowns to use later
                    })
                    .catch((error) => {
                        setControl(false)
                        if(error.message.includes('Reauthentication Required')) {
                            requiredReauthentication('OLFPageSetup(' + pageLoad + ')')
                        } else {
                            alert('An unexpected error occurred or the API is unavailable, please try again or contact support if the issue persists.')
                            setControl(true)
                        }
                    });
                }

            }).catch((error) => {
                alert('An unexpected error occurred or the API is unavailable, please try again or contact support if the issue persists.')
            });
        }
    }

    function handleRedirect(redirectState, idToken) {
        if(typeof redirectState === 'string') {
            redirectState = JSON.parse(redirectState)
        }

        setState(redirectState) // this sets all request values that are not dropdown menus

        // loop through all elements and set dropdown values with the json structure that they require
        Object.entries(redirectState).forEach(element => {
            let name = element[0]
            let value = element[1]
            let valueJson = {'label': value, 'value': value} // setting json structure

            if(name === 'work_in_state') {
                setWis(valueJson)
            } else if(name === 'pe_state') {
                setEmployeeState(valueJson)
            } else if(name === 'work_location') {
                setLocation(valueJson)
            } else if(name === 'business_cards') {
                setBusinesscards(valueJson)
            } else if(name === 'company_credit_card') {
                setCctype(valueJson)
            }
        });

        if(control) {
            // get it modal fields
            fetch((api_url + 'itrequest/' + redirectState.id), {headers: {Authorization: idToken}, method: 'GET'}).then((response) => response.json())
            .then((responseJson) => {
                if(responseJson.status === 401 && responseJson.message.includes('Reauthentication Required')) {
                    throw new Error('Reauthentication Required')
                }

                setItState(responseJson[0])
                Object.entries(responseJson[0]).forEach(element => {
                    let name = element[0]
                    let value = element[1]
                    let valueJson = {'label': value, 'value': value}

                    if(name === 'work_company' && value) {
                        setLocation(valueJson)
                    } else if(name === 'rehire' && value) {
                        setRehire(valueJson)
                    } else if(name === 'work_location' && value) {
                        setWorkLocation(valueJson)
                    } else if(name === 'provide_cell_phone' && value) {
                        setProvideCellPhone(valueJson)
                    } else if(name === 'computer' && value) {
                        setItState(prevState => ({
                            ...prevState,
                            computer: valueJson
                        }));
                    } else if(name === 'shipping_address' && value) {
                        if(value !== '') {
                            setShowShippingAddress(true)
                        }
                    } else if(name === 'sage_access' && value) {
                        setSageAccess(valueJson)
                        if(value == null) {
                            setShowSimilarSageEmployee(false)
                            setItState(prevState => ({
                                ...prevState,
                                similar_sage_employee: ''
                            }));
                        } else {
                            if(value === 'Yes') {
                                setShowSimilarSageEmployee(true)
                            } else if(value === 'No' || value === null) {
                                setShowSimilarSageEmployee(false)
                            }
                        }
                    }
                })
            })
            .catch((error) => {
                setControl(false)
                if(error.message.includes('Reauthentication Required')) {
                    requiredReauthentication('handleRedirect(' + JSON.stringify(redirectState) + ', \'' + idToken + '\')')
                } else {
                    alert('An unexpected error occurred or the API is unavailable, please try again or contact support if the issue persists.')
                    setControl(true)
                }
            })
        }
    }

    /**
     * Handler for IT modal inputs
     * @param {*} e event - this is the return value selected by the triggering event
     */
    const handleItChange = e => {
        const { name, value } = e.target;
        setItState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    /**
     * Handler for request form inputs
     * @param {*} e event - this is the return value selected by the triggering event
     */
    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    /**
     * Handler for request form dropdown menu inputs
     * @param {*} value this is the actual data stored in the options
     * @param {*} action this is the action event from the select
     */
    const onDataChange = (value, action) => {
        setState(prevState => ({
            ...prevState,
            [action.name]: value === null ? '' : value.value
        }));

        if(action.name === 'work_in_state') {
            setWis(value)
        } else if(action.name === 'pe_state') {
            setEmployeeState(value)
        } else if(action.name === 'work_location') {
            setLocation(value)
            setWorkLocation(null)
            if(value !== null && value.value === 'IPEC, INC.') {
                setState(prevState => ({
                    ...prevState,
                    annual_salary: '',
                    per_diem: ''
                }));
            } else if(value == null) {
                setState(prevState => ({
                    ...prevState,
                    ot_rate: '',
                    weekly_base_salary: '',
                    five_day_pd: '',
                    seven_day_pd: ''
                }));
            }
        } else if(action.name === 'business_cards') {
            setBusinesscards(value)
        } else if(action.name === 'company_credit_card') {
            setCctype(value)
        }
    }

    /**
     * Handler for IT modal dropdown menu inputs
     * @param {*} value this is the actual data stored in the options
     * @param {*} action this is the action event from the select
     */
    const onItDataChange = (value, action) => {
        setItState(prevState => ({
            ...prevState,
            [action.name]: value === null ? '' : value
        }));

        // if work company dropdown changes, we need to filter down the company locations list down to only locations associated with that company
        if(action.name === 'work_company') {
            setLocation(value)
            setWorkLocation(null)
        } else if(action.name === 'rehire') {
            setRehire(value)
        } else if(action.name === 'work_location') {
            setWorkLocation(value)
        } else if(action.name === 'provide_cell_phone') {
            setProvideCellPhone(value)
        } else if(action.name === 'sage_access') {
            setSageAccess(value)
            if(value == null) {
                setShowSimilarSageEmployee(false)
                setItState(prevState => ({
                    ...prevState,
                    similar_sage_employee: ''
                }));
            } else {
                if(value.value === 'Yes') {
                    setShowSimilarSageEmployee(true)
                } else if(value.value === 'No' || value.value === null) {
                    setShowSimilarSageEmployee(false)
                }
            }
        }
    }

    const handleAddressSwitch = (event) => {
        setShowShippingAddress(event.target.checked)
    }

    const handleCheckbox = (event) => {
        setItState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.checked
        }));
    }

    /**
     * Saves form data from IT modal
     */
    function makeItRequest() {
        setItState(prevState => ({
            ...prevState,
            employee_name: state.name,
            start_date: state.date_of_hire,
            work_company: location,
            report_to: state.report_to
        }));
        setShow(true)
    }
    /**
     * Gets current state and resets certain values when an offer letter update occurs
     */
    function resetValuesOnUpdate() {
        var resetParams = {...state};
        let updateTimeStamp = new Date().toISOString()
        resetParams['approval_status'] = 'unapproved';
        resetParams['approval_date'] = '';
        resetParams['approving_hr_practitioner'] = '';
        resetParams['blob_id'] = '';
        resetParams['verification_status'] = 'unverified';
        resetParams['rejection_reason'] = '';
        resetParams['verification_date'] = '';
        resetParams['envelope_status'] = 'Unsent';
        resetParams['envelope_id'] = '';
        resetParams['request_date'] = updateTimeStamp;

        if(control) {
            fetch((api_url + 'requests/' + state.id), {headers: {Authorization: token.idToken}, method: 'PUT', body: JSON.stringify(resetParams)})
            .then((response) => {
                if(response.status === 200){
                    return 'OK'
                } else {
                    return response.json()
                }
            })
            .then((json) => {
                if(json !== 'OK') {
                    if(json.status === 401 && json.message.includes('Reauthentication Required')) {
                        throw new Error('Reauthentication Required')
                    }
                }
            })
            .catch((error) => {
                setControl(false)
                if(error.message.includes('Reauthentication Required')) {
                    requiredReauthentication('resetValuesOnUpdate()')
                } else {
                    alert('An unexpected error occurred or the API is unavailable, please try again or contact support if the issue persists.')
                    setControl(true)
                }
            });
        }
    }

    /**
     * Function to handle the submit button.
     * @param {*} e event - this is the return value selected by the triggering event
     */
    function handleRequest() {
        setUserResponse('')
        setSubmit(true)
        OLFPageSetup(false)
        var param = {'name': state.name, 'email': state.email,  'date_of_hire': state.date_of_hire, 'position': state.position, 'work_location': state.work_location, 'report_to': state.report_to, 'hourly_rate': state.hourly_rate, 'annual_salary': state.annual_salary, 'bonus': state.bonus, 'vacation': state.vacation, 'per_diem': state.per_diem, 'auto_allowance': state.auto_allowance,  'cell_phone_reimbursement': state.cell_phone_reimbursement, 'company_credit_card': state.company_credit_card, 'company_credit_card_limit': state.company_credit_card_limit, 'business_cards': state.business_cards, 'company_equipment': state.company_equipment, 'work_in_state': state.work_in_state, 'commission': state.commission, 'comments': state.comments, "weekly_base_salary": state.weekly_base_salary, "ot_rate": state.ot_rate, "five_day_pd": state.five_day_pd, "seven_day_pd": state.seven_day_pd, "manager_title": state.manager_title, 'requestor_name': accounts[0].idTokenClaims.name, 'approval_status': 'unapproved', 'verification_status': 'unverified', 'request_date': new Date().toISOString(), 'pe_street_address': state.pe_street_address, 'pe_city': state.pe_city, 'pe_state': state.pe_state, 'pe_zip': state.pe_zip, 'envelope_status': 'Unsent'}
        var invalidField = false
        var invalidFields = []
        const requiredFields = ['name', 'email', 'date_of_hire', 'position', 'report_to', 'manager_title', 'work_in_state', 'work_location']

        // field verification and sanitation
        Object.keys(param).forEach(fieldName => {
            if(param[fieldName]) { param[fieldName] = sanitize(param[fieldName]) }
            if(!validate(fieldName, param[fieldName])) {
                invalidField = true
                invalidFields.push(fieldName)
                if(requiredFields.includes(fieldName)) {
                    document.getElementById(fieldName).style.border = '3px solid red'
                }
            } else {
                if(requiredFields.includes(fieldName)) {
                    document.getElementById(fieldName).style.border = '1px solid black'
                }
            }
        })

        if(invalidField) { // if we found an invalid input in one of the fields, set submit to false and return false to stop execution
            setSubmit(false)
            return false
        }

        var method = 'POST'
        var uri_params = ''
        var currentTimestamp = new Date().toISOString()
        // api call will be a PUT if coming from redirect, else post
        if(redirect) {
            method = 'PUT'
            uri_params = '/' + state.id
            param['update_action'] = 'edit'
        }

        if(control) {
            if( (redirect && currentTimestamp > state.request_date) || !redirect ) { // (if we're here from a redirect & the record hasn't been updated since it was fetched) OR we're not here from a redirect
                fetch((api_url + 'requests' + uri_params), {headers: {Authorization: token.idToken}, method: method, body: JSON.stringify(param)}).then((response) => {
                    if(response.status === 200 && method === 'POST') {
                        return response.json()
                    } else if(response.status === 200 && method === 'PUT') {
                        return response
                    } else {
                        if(response.status === 401) {
                            return response.json()
                        }
                        return null
                    }
                }).then((responseJson) => {
                    if(responseJson?.status === 401 && responseJson?.message.includes('Reauthentication Required')) {
                        throw new Error('Reauthentication Required')
                    }

                    if(responseJson !== null) {
                        if(redirect) {
                            resetValuesOnUpdate()
                        }

                        setState({ name: "", email: "",  date_of_hire: "", position: "", work_location: "", report_to: "", hourly_rate: "", annual_salary: "", bonus:"", vacation:"", per_diem:"", auto_allowance:"",  cell_phone_reimbursement:"", company_credit_card:"", company_credit_card_limit:"", business_cards:"", company_equipment:"", work_in_state:"", commission:"", comments:"", weekly_base_salary: "", ot_rate: "", five_day_pd: "", seven_day_pd: "", manager_title: "", pe_street_address: "", pe_city: "", pe_state: "", pe_zip: ""})
                        setLocation(null)
                        setEmployeeState(null)
                        setWis(null)
                        setSubmit(false)
                        setCctype(null)
                        setBusinesscards(null)

                        var itparam = {'request_id': responseJson?.item_id, 'employee_name': itState.employee_name, 'shipping_address': itState.shipping_address, 'pe_middle_name': itState.pe_middle_name, 'keyboard_mouse': itState.keyboard_mouse, 'mapped_drives': itState.mapped_drives, 'vpn_access': itState.vpn_access, 'docking_station': itState.docking_station,'sage_access': itState.sage_access?.value, 'similar_sage_employee': itState.similar_sage_employee, 'cell_phone_type': itState.cell_phone_type, 'provide_cell_phone': itState.provide_cell_phone?.value, 'rehire': itState.rehire?.value, 'department': itState.department, 'cell_phone_number': itState.cell_phone_number, 'start_date': itState.start_date, 'work_company': itState.work_company?.value, 'work_location': itState.work_location?.value, 'similar_employee': itState.similar_employee, 'computer': itState.computer?.value, 'monitors': itState.monitors, 'report_to': itState.report_to, 'requested_software': itState.requested_software, 'other_requests': itState.other_requests}
                        fetch((api_url + 'itrequests'), {headers: {Authorization: token.idToken}, method: method, body: JSON.stringify(itparam)}).then((response) => {
                            if(response.status === 401 && response.message.includes('Reauthentication Required')) {
                                throw new Error('Reauthentication Required')
                            }

                            if(response.status !== 200) {
                                setUserResponse("Request created with HR, IT request could not be created. Please submit a ticket.")
                                setSubmit(false);
                            } else {
                                setUserResponse("Success!");
                            }
                        }).catch((error) => {
                            setUserResponse("Request created with HR, IT request could not be created. Please submit a ticket.")
                            setSubmit(false);
                        });

                        setItMade(false)
                        setItState({employee_name: '', pe_middle_name: '', start_date: '', work_company:null, work_location:'', similar_employee:'', computer:'', sage_access: '', provide_cell_phone: '', monitors:'', report_to:'', requested_software:'', other_requests:''}) // keyboard_mouse:false,
                        setShowShippingAddress(false)
                        setRehire(null);
                        setProvideCellPhone(null);
                        setSageAccess(null);
                        setWorkLocation(null);
                    } else {
                        setUserResponse('Error! Try again later.')
                        setSubmit(false)
                    }
                }).catch((error) => {
                    setUserResponse('Error! Try again later.')
                    setSubmit(false)
                    setControl(false)
                    if(error.message.includes('Reauthentication Required')) {
                        requiredReauthentication('handleRequest()')
                    } else {
                        alert('An unexpected error occurred or the API is unavailable, please try again or contact support if the issue persists.')
                        setControl(true)
                    }
                });
            } else {
                alert("This request has been updated since it has been fetched")
            }
        }
    };

    return (
        <>
            <Modal
                size='xl'
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        IT Equipment/User Account Request
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container rowSpacing={1} columnSpacing={2}>
                            <Grid item xs={6}>
                                <h5 className="field-name">Employee Name: </h5>
                                <input type="text" id="employee_name" name="employee_name" value={itState?.employee_name ? itState?.employee_name : state.name} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className='field-name'>New or Rehire?</h5>
                                <Select
                                    options={[{label: 'New', value: 'New'}, {label: 'Rehire', value: 'Rehire'}]}
                                    className='request-dropdowns'
                                    isClearable={true}
                                    name='rehire'
                                    onChange={onItDataChange}
                                    value={rehire}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Similar Employee: </h5>
                                <input type="text" id="similar_employee" name="similar_employee" placeholder='Someone with similar access...' value={itState.similar_employee} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className='field-name'>Department</h5>
                                <input type="text" id="department" name="department" value={itState.department} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Report To: </h5>
                                <input type="text" id="report_to" name="report_to" placeholder='Manager name...' value={itState.report_to} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Cell Phone Number</h5>
                                <input type='text' id='cell_phone_number' name='cell_phone_number' value={itState.cell_phone_number} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Work Company: </h5>
                                <Select
                                    options={companyNames}
                                    className='request-dropdowns'
                                    isClearable={true}
                                    placeholder="Select a Company..."
                                    name='work_company'
                                    onChange={onItDataChange}
                                    value={location}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Company Location: </h5>
                                <Select
                                    options={itState.work_company === null ? [] : companyLocations.filter((tempLocation) => tempLocation.company_id === location?.id)}
                                    className='request-dropdowns'
                                    isClearable={true}
                                    placeholder="Select a location..."
                                    name='work_location'
                                    onChange={onItDataChange}
                                    value={workLocation}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Start Date: </h5>
                                <input type="date" id="start_date" name="start_date" value={itState.start_date} onChange={handleItChange} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className='field-name'>Sage Access?</h5>
                                <Select
                                    options={[{label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}]}
                                    className='request-dropdowns'
                                    name="sage_access"
                                    isClearable={true}
                                    placeholder="Select..."
                                    onChange={onItDataChange}
                                    value={sageAccess}
                                />
                            </Grid>
                            {showSimilarSageEmployee &&
                                <>
                                    <Grid item xs={6}>
                                        <h5 className='field-name'>Whose Sage permissions can we mirror?</h5>
                                        <input type="text" id="similar_sage_employee" name="similar_sage_employee" value={itState.similar_sage_employee} onChange={handleItChange} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <h5 className='field-name'>Employee's Middle Name (Needed for Sage access)</h5>
                                        <input type="text" id="pe_middle_name" name="pe_middle_name" value={itState.pe_middle_name} onChange={handleItChange} />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12}>
                                <h4>Equipment/Software</h4>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className='field-name'>Cell Phone</h5>
                                <Select
                                    options={[{label: 'Apple', value: 'Apple'}, {label: 'Android', value: 'Android'}]}
                                    className='request-dropdowns'
                                    name="provide_cell_phone"
                                    isClearable={true}
                                    placeholder="Apple or Android? Leave blank if none"
                                    onChange={onItDataChange}
                                    value={provideCellPhone}
                                />
                            </Grid>
                            {/* {itState.provide_cell_phone !== '' ?
                                <>
                                    <Grid item xs={6}>
                                        <h5 className='field-name'>Phone Model</h5>
                                        <input type='text' id='phone_model' name='phone_model' value={itState.phone_model} onChange={handleItChange} />
                                    </Grid>
                                </>
                                :
                                <></>
                            } */}
                            <Grid item xs={6}>
                                <h5 className="field-name">Computer</h5>
                                <Select options={[{label: 'Laptop - Standard', value: 'Laptop - Standard'}, {label: 'Laptop - 10-Key', value: 'Laptop - 10-Key'}, {label: 'Laptop - Engineering', value: 'Laptop - Engineering'},  {label: 'Desktop', value: 'Desktop'}, {label: 'Desktop - Engineering', value: 'Desktop - Engineering'}, {label: 'Tablet', value: 'Tablet'}, {label: 'None', value: 'None'}]} className='request-dropdowns' name="computer" isClearable={true} placeholder="Select option..."  onChange={onItDataChange}  value={itState.computer} />
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Monitors</h5>
                                <input type="text" id="monitors" name="monitors" value={itState.monitors} onChange={handleItChange} placeholder='Enter quantity'/>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid textAlign={'center'} container rowSpacing={1} columnSpacing={2}>
                            <Grid item xs={3}>
                                <h5 className="field-name">Keyboard & Mouse</h5>
                                <Checkbox name='keyboard_mouse' checked={itState.keyboard_mouse} onChange={handleCheckbox} style={{ transform: "scale(1.4)" }} />
                            </Grid>
                            <Grid item xs={3}>
                                <h5 className='field-name'>Docking Station</h5>
                                <Checkbox name='docking_station' checked={itState.docking_station} onChange={handleCheckbox} style={{ transform: "scale(1.4)" }} />
                            </Grid>
                            <Grid item xs={3}>
                                <h5 className='field-name'>VPN Access</h5>
                                <Checkbox name='vpn_access' checked={itState.vpn_access} onChange={handleCheckbox} style={{ transform: "scale(1.4)" }} />
                            </Grid>
                            <Grid item xs={3}>
                                <h5 className='field-name'>Mapped Drives?</h5>
                                <Checkbox name='mapped_drives' checked={itState.mapped_drives} onChange={handleCheckbox} style={{ transform: "scale(1.4)" }} />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container direction={'column'} rowSpacing={1} columnSpacing={2}>
                            <Grid item xs={6}>
                                <FormGroup>
                                    <FormControlLabel componentsProps={{ typography: { variant: 'h5' } }} control={<Switch checked={showShippingAddress} onChange={handleAddressSwitch} />} label="Ship to employee?" />
                                </FormGroup>
                            </Grid>
                            {showShippingAddress &&
                                <>
                                    <Grid item xs={6}>
                                        <h5 className='field-name'>Shipping Address</h5>
                                        <input type="text" id="shipping_address" name="shipping_address" value={itState.shipping_address} onChange={handleItChange} placeholder='Enter shipping address'/>
                                    </Grid>
                                </>
                            }
                        </Grid>
                        <br />
                        <Grid container rowSpacing={1} columnSpacing={2}>
                            <Grid item xs={6}>
                                <h5 className="field-name">What software is needed?</h5>
                                <TextField placeholder='Example: Office 365' fullWidth minRows={4} maxRows={6} variant='filled' multiline id="requested_software" name="requested_software" value={itState.requested_software} onChange={handleItChange}></TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Additional Notes: </h5>
                                <TextField placeholder='Comments...' fullWidth minRows={4} maxRows={6} variant='filled' multiline id="other_requests" name="other_requests" value={itState.other_requests} onChange={handleItChange}></TextField>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => {setShow(false);setItMade(true)}}>Save Values</Button>
                </Modal.Footer>
            </Modal>


            <br /><br /><br />
            <div className="page-container">
                <h2 className="page-title">Offer Letter Request Form:</h2><br />
                <div className="request-column-holder">
                    <Box sx={{ flexGrow: 1 }}>
                        <div className='general_employee_info'>
                            <Grid  container rowSpacing={2} columnSpacing={2}>
                                <Grid item xs={12}>
                                    <h3>General Employee Information</h3>
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Legal Name: </h5>
                                    <input type="text" id="name" name="name" value={state.name} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Personal Email: </h5>
                                    <input type="text" id="email" name="email" value={state.email} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Street Address: </h5>
                                    <input type="text" id="pe_street_address" name="pe_street_address" value={state.pe_street_address} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">City: </h5>
                                    <input type="text" id="pe_city" name="pe_city" value={state.pe_city} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">State: </h5>
                                    <Select options={[{label: 'AL', value: 'AL'}, {label: 'AK', value: 'AK'}, {label: 'AZ', value: 'AZ'}, {label: 'AR', value: 'AR'}, {label: 'CA', value: 'CA'}, {label: 'CO', value: 'CO'}, {label: 'CT', value: 'CT'}, {label: 'DE', value: 'DE'}, {label: 'DC', value: 'DC'}, {label: 'FL', value: 'FL'}, {label: 'GA', value: 'GA'}, {label: 'HI', value: 'HI'}, {label: 'ID', value: 'ID'}, {label: 'IL', value: 'IL'}, {label: 'IN', value: 'IN'}, {label: 'IA', value: 'IA'}, {label: 'KS', value: 'KS'}, {label: 'KY', value: 'KY'}, {label: 'LA', value: 'LA'}, {label: 'ME', value: 'ME'}, {label: 'MD', value: 'MD'}, {label: 'MA', value: 'MA'}, {label: 'MI', value: 'MI'}, {label: 'MN', value: 'MN'}, {label: 'MS', value: 'MS'}, {label: 'MO', value: 'MO'}, {label: 'MT', value: 'MT'}, {label: 'NE', value: 'NE'}, {label: 'NV', value: 'NV'}, {label: 'NH', value: 'NH'}, {label: 'NJ', value: 'NJ'}, {label: 'NM', value: 'NM'}, {label: 'NY', value: 'NY'}, {label: 'NC', value: 'NC'}, {label: 'ND', value: 'ND'}, {label: 'OH', value: 'OH'}, {label: 'OK', value: 'OK'}, {label: 'OR', value: 'OR'}, {label: 'PA', value: 'PA'}, {label: 'RI', value: 'RI'}, {label: 'SC', value: 'SC'}, {label: 'SD', value: 'SD'}, {label: 'TN', value: 'TN'}, {label: 'TX', value: 'TX'}, {label: 'UT', value: 'UT'}, {label: 'VT', value: 'VT'}, {label: 'VA', value: 'VA'}, {label: 'WA', value: 'WA'}, {label: 'WV', value: 'WV'}, {label: 'WI', value: 'WI'}, {label: 'WY', value: 'WY'}]}
                                        id='pe_state'
                                        className='request-dropdowns'
                                        name="pe_state"
                                        isClearable={true}
                                        placeholder="Select state..."
                                        onChange={onDataChange}
                                        value={employeeState}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Zip Code: </h5>
                                    <input type="text" id="pe_zip" name="pe_zip" value={state.pe_zip} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Date of Hire:</h5>
                                    <input type="date" id="date_of_hire" name="date_of_hire" value={state.date_of_hire} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Position: </h5>
                                    <input type="text" id="position" name="position" value={state.position} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Report To: </h5>
                                    <input type="text" id="report_to" name="report_to" value={state.report_to} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Manager Title: </h5>
                                    <input type="text" id="manager_title" name="manager_title" value={state.manager_title} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Work in State:</h5>
                                    <Select options={[{label: 'Alabama', value: 'Alabama'}, {label: 'Alaska', value: 'Alaska'}, {label: 'Arizona', value: 'Arizona'}, {label: 'Arkansas', value: 'Arkansas'}, {label: 'California', value: 'California'}, {label: 'Colorado', value: 'Colorado'}, {label: 'Connecticut', value: 'Connecticut'}, {label: 'Delaware', value: 'Delaware'}, {label: 'District of Columbia', value: 'District of Columbia'}, {label: 'Florida', value: 'Florida'}, {label: 'Georgia', value: 'Georgia'}, {label: 'Hawaii', value: 'Hawaii'}, {label: 'Idaho', value: 'Idaho'}, {label: 'Illinois', value: 'Illinois'}, {label: 'Indiana', value: 'Indiana'}, {label: 'Iowa', value: 'Iowa'}, {label: 'Kansas', value: 'Kansas'}, {label: 'Kentucky', value: 'Kentucky'}, {label: 'Louisiana', value: 'Louisiana'}, {label: 'Maine', value: 'Maine'}, {label: 'Maryland', value: 'Maryland'}, {label: 'Massachusetts', value: 'Massachusetts'}, {label: 'Michigan', value: 'Michigan'}, {label: 'Minnesota', value: 'Minnesota'}, {label: 'Mississippi', value: 'Mississippi'}, {label: 'Missouri', value: 'Missouri'}, {label: 'Montana', value: 'Montana'}, {label: 'Nebraska', value: 'Nebraska'}, {label: 'Nevada', value: 'Nevada'}, {label: 'New Hampshire', value: 'New Hampshire'}, {label: 'New Jersey', value: 'New Jersey'}, {label: 'New Mexico', value: 'New Mexico'}, {label: 'New York', value: 'New York'}, {label: 'North Carolina', value: 'North Carolina'}, {label: 'North Dakota', value: 'North Dakota'}, {label: 'Ohio', value: 'Ohio'}, {label: 'Oklahoma', value: 'Oklahoma'}, {label: 'Oregon', value: 'Oregon'}, {label: 'Pennsylvania', value: 'Pennsylvania'}, {label: 'Rhode Island', value: 'Rhode Island'}, {label: 'South Carolina', value: 'South Carolina'}, {label: 'South Dakota', value: 'South Dakota'}, {label: 'Tennessee', value: 'Tennessee'}, {label: 'Texas', value: 'Texas'}, {label: 'Utah', value: 'Utah'}, {label: 'Vermont', value: 'Vermont'}, {label: 'Virginia', value: 'Virginia'}, {label: 'Washington', value: 'Washington'}, {label: 'West Virginia', value: 'West Virginia'}, {label: 'Wisconsin', value: 'Wisconsin'}, {label: 'Wyoming', value: 'Wyoming'}]}
                                        id='work_in_state'
                                        className='request-dropdowns'
                                        name="work_in_state"
                                        isClearable={true}
                                        placeholder="Select state..."
                                        onChange={onDataChange}
                                        value={wis}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <h5 className="field-name">Work Location: </h5>
                                    <Select
                                        id='work_location'
                                        options={companyNames}
                                        className='request-dropdowns'
                                        isClearable={true}
                                        placeholder="Select location..."
                                        name='work_location'
                                        onChange={onDataChange}
                                        value={location}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Grid container rowSpacing={2} columnSpacing={2}>
                            <Grid item xs={12}>
                                <br />
                                <h3>Salary and Benefits</h3>
                            </Grid>
                            {state.work_location !== 'IPEC, INC.' ?
                            <>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">Annual Salary:</h5>
                                            <input type="text" id="annual_salary" name="annual_salary" value={state.annual_salary} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">Hourly Rate:</h5>
                                            <input type="text" id="hourly_rate" name="hourly_rate" value={state.hourly_rate} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">Per Diem: </h5>
                                            <input type="text" id="per_diem" name="per_diem" value={state.per_diem} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">Hourly Rate:</h5>
                                            <input type="text" id="hourly_rate" name="hourly_rate" value={state.hourly_rate} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">Weekly Base Salary:</h5>
                                            <input type="text" id="weekly_base_salary" name="weekly_base_salary" value={state.weekly_base_salary} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">5 Day Per Diem: </h5>
                                            <input type="text" id="five_day_pd" name="five_day_pd" value={state.five_day_pd} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={6}>
                                    <Tooltip title='Numeric values only, do not need "$"'>
                                        <span>
                                            <h5 className="field-name">7 Day Per Diem: </h5>
                                            <input type="text" id="seven_day_pd" name="seven_day_pd" value={state.seven_day_pd} onChange={handleChange} placeholder='Enter dollar amount...' />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </>}
                            <Grid item xs={6}>
                                <Tooltip title='Numeric values only, do not need "$"'>
                                    <span>
                                        <h5 className="field-name">OT Rate:</h5>
                                        <input type="text" id="ot_rate" name="ot_rate" value={state.ot_rate} onChange={handleChange} placeholder='Enter dollar amount...' />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <Tooltip title='Numeric values only, do not need "$"'>
                                    <span>
                                        <h5 className="field-name">Bonus:</h5>
                                        <input type="text" id="bonus" name="bonus" value={state.bonus} onChange={handleChange} placeholder='Enter dollar amount...' />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Vacation:</h5>
                                <input placeholder='Enter number only, example: 3' type="text" id="vacation" name="vacation" value={state.vacation} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={12}>
                                <h3>Other Provisions</h3>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Business Cards:</h5>
                                <Select options={[{label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}]} className='request-dropdowns' name="business_cards" isClearable={true} placeholder="Select option..."  onChange={onDataChange}  value={businesscards} />
                            </Grid>
                            <Grid item xs={6}>
                                <Tooltip title='Numeric values only, do not need "$"'>
                                    <span>
                                        <h5 className="field-name">Cell Phone Reimbursement:</h5>
                                        <input placeholder='Enter dollar amount..' type="text" id="cell_phone_reimbursement" name="cell_phone_reimbursement" value={state.cell_phone_reimbursement} onChange={handleChange} />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Company Credit Card:</h5>
                                <Select
                                    options={[{label: 'P-Card', value: 'P-Card'}, {label: 'T&E Card', value: 'T&E Card'}, {label: 'P-Card and T&E Card', value: 'P-Card and T&E Card' }]}
                                    className='request-dropdowns'
                                    name="company_credit_card"
                                    isClearable={true}
                                    placeholder="Select option..."
                                    onChange={onDataChange}
                                    value={cctype}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Tooltip title='Numeric values only, do not need "$"'>
                                    <span>
                                        <h5 className="field-name">Company Credit Card Limit:</h5>
                                        <input type="text" id="company_credit_card_limit" name="company_credit_card_limit" disabled={!cctype} value={state.company_credit_card_limit} onChange={handleChange} />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <Tooltip title='Numeric values only, do not need "$"'>
                                    <span>
                                        <h5 className="field-name">Auto Allowance:</h5>
                                        <input type="text" id="auto_allowance" name="auto_allowance" value={state.auto_allowance} onChange={handleChange} placeholder='Enter dollar amount...' />
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Commission:</h5>
                                <input type="text" id="commission" name="commission" value={state.commission} onChange={handleChange}/>
                            </Grid>
                            <Grid item xs={6}>
                                <h5 className="field-name">Company Equipment:</h5>
                                <input type="text" id="company_equipment" name="company_equipment" value={state.company_equipment} onChange={handleChange} />
                            </Grid>
                            <Grid item xs={6}>

                            </Grid>
                            <Grid item xs={6}>
                                <Button variant="primary" onClick={makeItRequest}>{itMade === false ? 'Make IT Equipment Request':'See/Change IT Request'}</Button>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
                <h5 className="field-name">Comments:</h5>
                <textarea id="comments" name="comments" value={state.comments} onChange={handleChange}></textarea><br/><br />
                <Button className="submit-button" variant='danger' onClick={() => handleRequest()} disabled={submit}>{submit ? <CircularProgress size={24}/> : (redirect ? 'Update Request' : 'Submit Request')}</Button>
                <h5 style={{textAlign: 'center', color: (userResponse==='Success!' ? 'green': 'red')}}>{userResponse}</h5>
            </div>
        </>
    );
}

export default OfferLetterRequestForm;